export default "__VITE_ASSET__BJ$OePVb__"